import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import FollowUsStore from './store';

const styles = require('./index.less');

const FollowUs = ({ store }) => {
  store.use();

  return (
    <div className={styles.follow}>
      <div className={styles.slogan} />
      <div className={styles.followList}>
        {store.followList.map(item => (
          <div className={styles.followItem} key={item.id} onClick={() => store.clickNav(item)}>
            <div className={styles.followImgBox}>
              <img src={item.img} alt={item.name} className={styles.followImg} />
              <div className={styles.qrcode}>
                <img src={item.qrcode} alt={item.name} />
              </div>
            </div>
            <img src={item.text} alt={item.name} className={styles.followText} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default wrapStore(FollowUs, FollowUsStore);
